export default __webpack_public_path__ + "static/media/p2p-banners-cn.b06fb162.webp";